
import { queueDomainDeletion } from "./queue";
import { removeDomainFromVercel } from "./remove-domain-vercel";
import { Panda0GraphqlClient } from "@panda0/panda0-graphql";

// Mark the domain as deleted
// We'll delete the domain and its links via a cron job
export async function markDomainAsDeleted({
  domain,
  workspaceId,
  panda0gql
}: {
  domain: string;
  workspaceId: string;
  panda0gql: Panda0GraphqlClient
}) {
  await panda0gql.mutation({
    updateAppLink: {
      __args: {
        where: {
          domain: {
            _eq: domain
          }
        },
        _set: {
          teamId: null
        }
      },
      returning: {
        id: true
      }
    }
  });

  const response = await Promise.allSettled([
    removeDomainFromVercel(domain, panda0gql),
    panda0gql.mutation({
      updateSaasDomain: {
        __args: {
          where: {
            slug: {
              _eq: domain
            }
          },
          _set: {
            teamId: null
          }
        },
        returning: {
          id: true,
        }
      }
    })]);

  await queueDomainDeletion({
    domain,
  });

  response.forEach((promise) => {
    if (promise?.status === "rejected") {
      console.error("markDomainAsDeleted", {
        reason: promise.reason,
        domain,
        workspaceId,
      });
    }
  });
}
